import { render, staticRenderFns } from "./LinkClicks.vue?vue&type=template&id=23457622&scoped=true&"
import script from "./LinkClicks.vue?vue&type=script&lang=ts&"
export * from "./LinkClicks.vue?vue&type=script&lang=ts&"
import style0 from "./LinkClicks.vue?vue&type=style&index=0&id=23457622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23457622",
  null
  
)

export default component.exports